import { BaseModalComponent } from './../base/base-modal.component';
import { POSTAL_CODE_REGEX } from './../../../../../shared/regular-expressions/regex';
import { FormGenModel } from './../../../../../shared/models/form-gen.model';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { ModalController, NavParams } from '@ionic/angular';
import { setValidators } from '../../../../../shared/validators/set-validators';

export const ADDRESS_LIST: FormGenModel[] = [
  { label: 'LINE', value: '0', required: false, formArray: 'line' },
  { label: 'COUNTRY', value: 'country' },
  {
    label: 'STATE', value: 'state'
  },
  { label: 'POSTALCODE', value: 'postalCode', autofocus: true },
  { label: 'CITY', value: 'city' },
];

export function getAddressFormGroup(): FormGroup {
  return new FormGroup({
    use: new FormControl(''),
    line: new FormArray([
      new FormControl()
    ]),
    city: new FormControl(''),
    state: new FormControl(''),
    postalCode: new FormControl('', Validators.pattern(POSTAL_CODE_REGEX)),
    country: new FormControl('')
  });
}

@Component({
  selector: 'inc-address',
  templateUrl: './../base/base-modal.component.html'
})
export class AddressComponent extends BaseModalComponent implements OnInit {
  title = 'ADDRESS';
  formGenList = ADDRESS_LIST;

  constructor(modalController: ModalController, private navParams: NavParams) {
    super(modalController);
    this.reset(getAddressFormGroup());
  }

  ngOnInit() {
    super.ngOnInit();
    const extraValidators = this.navParams.get('extraValidators');
    if (extraValidators) { this.form = setValidators(this.form, extraValidators); }
  }

  save() {
    this.baseSave({ value: { address: this.form } });
  }
}
